import gsap from "gsap";

import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// Helper to safely select elements for GSAP animations
const safeSelect = (target) => {
  if (typeof target === 'string') {
    const elements = document.querySelectorAll(target);
    return elements.length > 0 ? elements : null;
  }
  return target;
};

export const animateWithGsap = (target, animationProps, scrollProps) => {
  const elements = safeSelect(target);
  if (!elements) {
    // Target not found - skip animation silently
    return;
  }
  
  gsap.to(target, {
    ...animationProps,
    scrollTrigger: {
      trigger: target,
      toggleActions: 'restart reverse restart reverse',
      start: 'top 85%',
      ...scrollProps,
    }
  })
}

export const animateWithGsapTimeline = (timeline, rotationRef, rotationState, firstTarget, secondTarget, animationProps) => {
  // Guard: check if rotationRef is available
  if (!rotationRef?.current?.rotation) {
    return;
  }

  timeline.to(rotationRef.current.rotation, {
    y: rotationState,
    duration: 1,
    ease: 'power2.inOut'
  })

  // Guard: only animate targets that exist in DOM
  if (safeSelect(firstTarget)) {
    timeline.to(
      firstTarget,
      {
        ...animationProps,
        ease: 'power2.inOut'
      },
      '<'
    )
  }

  if (safeSelect(secondTarget)) {
    timeline.to(
      secondTarget,
      {
        ...animationProps,
        ease: 'power2.inOut'
      },
      '<'
    )
  }
}

export const fadeInUp = (element, duration = 1, delay = 0.2) => {
  // Guard: check if element exists
  if (!safeSelect(element)) {
    return;
  }
  
  gsap.fromTo(
      element,
      { opacity: 0, y: 50 },
      {
          opacity: 1,
          y: 0,
          duration,
          delay,
          ease: "power3.out",
          scrollTrigger: {
              trigger: element,
              start: "top 80%",
          },
      }
  );
};